/**
 * Clear Cache Utility
 * 
 * Provides functions to clear various types of cache and handle development issues
 */

/**
 * Clear all application caches
 * Useful for debugging and resolving cache-related issues
 */
export const clearAllCaches = async () => {
  try {
    console.log('🧹 Clearing all caches...')
    
    // Clear localStorage
    localStorage.clear()
    console.log('✅ localStorage cleared')
    
    // Clear sessionStorage
    sessionStorage.clear()
    console.log('✅ sessionStorage cleared')
    
    // Clear IndexedDB
    if ('indexedDB' in window) {
      const databases = await indexedDB.databases()
      await Promise.all(
        databases.map(db => {
          return new Promise((resolve, reject) => {
            const deleteReq = indexedDB.deleteDatabase(db.name)
            deleteReq.onsuccess = () => resolve()
            deleteReq.onerror = () => reject(deleteReq.error)
          })
        })
      )
      console.log('✅ IndexedDB cleared')
    }
    
    // Clear service worker cache
    if ('serviceWorker' in navigator && 'caches' in window) {
      const cacheNames = await caches.keys()
      await Promise.all(cacheNames.map(name => caches.delete(name)))
      console.log('✅ Service Worker caches cleared')
    }
    
    console.log('✅ All caches cleared successfully')
    return true
    
  } catch (error) {
    console.error('❌ Error clearing caches:', error)
    return false
  }
}

/**
 * Handle HMR React null error during development
 * Attempts to recover from React becoming null during hot reloads
 */
export const handleHMRReactError = () => {
  if (import.meta.env.DEV) {
    console.log('🔥 HMR React Error Recovery: Attempting to fix React null error...')
    
    // Force reload the page to reset React state
    setTimeout(() => {
      console.log('🔄 HMR React Error Recovery: Performing hard refresh...')
      window.location.reload()
    }, 100)
  }
}

/**
 * Check if current error is the React HMR null error
 */
export const isReactHMRError = (error) => {
  return error && 
         error.message && 
         (error.message.includes("Cannot read properties of null (reading 'useEffect')") ||
          error.message.includes("Cannot read properties of undefined (reading 'useEffect')") ||
          error.message.includes("React is null") ||
          error.message.includes("useEffect is null"))
}

// Make available globally for console debugging
if (typeof window !== 'undefined') {
  window.clearAllCaches = clearAllCaches
} 

console.log('🧹 Cache utilities loaded') 